import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'Determines which IDC rate is applicable for a given project',
    name: 'IDC Rate Group',
    partialId: PartialId.Standard.create('idc_rate_group'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
